/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'staffList' , params: {brandPath: this.$route.params.brandPath}} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">スタッフ編集</p>
                </div>
            </div>
        </div>
        <StaffEdit/>
    </div>
</template>

<script>
    import StaffEdit from '@/app/components/StaffEdit.vue'
    export default {
        name: 'manageStaffEdit',
        components: {
            StaffEdit
        }
    }
</script>
